import { __assign, __rest } from "tslib";
/* eslint-disable react/prop-types */

/** @jsx jsx */

import { jsx } from '@emotion/core';
import { forwardRef } from 'react';
var element = {
  div: 'div',
  ul: 'ul',
  li: 'li',
  head: 'head',
  span: 'span',
  section: 'section',
  article: 'article'
};

var ViewRef = function ViewRef(_a, ref) {
  var children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'div' : _b,
      rest = __rest(_a, ["children", "variant"]) // component,
  ; // const Component = component || element[variant]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var Component = element[variant];
  return jsx(Component, __assign({}, rest, {
    ref: ref
  }), children);
};

export var View = forwardRef(ViewRef);